import React, { useState } from 'react'

export const GradeLogViewer = ({ gradeLog }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpenState = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div>
      {isOpen ? (
        <div
          className="gradeLog-open"
          style={{
            cursor: 'pointer',
            border: '1px solid darkblue',
            marginTop: '.1em',
            padding: '4px',
            borderRadius: '4px',
          }}
        >
          <div
            style={{
              float: 'right',
            }}
          >
            <i
              onClick={handleOpenState}
              className="close-grade-viwer far fa-window-close fa-2x"
            />
          </div>
          <div className="grade-log-container">
            <div className="user-panel openStyles">
              <h4>User</h4>
              <p>Email: {gradeLog.user.email}</p>
              <p>Name: {gradeLog.user.fullName}</p>
            </div>
            <div className="context-panel openStyles">
              <h4>Context</h4>
              <p>ID: {gradeLog.context.id}</p>
              <p>Context ID: {gradeLog.context.contextId}</p>
              <p>Context Title: {gradeLog.context.contextTitle}</p>
              <p>Context Label: {gradeLog.context.contextLabel}</p>
              <p>Line Items: {gradeLog.context.lineItems}</p>
              <p>Names and Roles: {gradeLog.context.namesRoles}</p>
            </div>
            <div className="activity-panel openStyles">
              <h4>Resource Link</h4>
              <p>Id: {gradeLog.resourceLink && gradeLog.resourceLink.id}</p>
              <p>Guid: {gradeLog.resourceLink && gradeLog.resourceLink.guid}</p>
              <p>
                URL:{' '}
                {gradeLog.resourceLink && gradeLog.resourceLink.lineItemUrl}
              </p>
            </div>
            <div className="diagnostic-panel openStyles">
              <h4>Diagnostic Information:</h4>
              <p>Response: {gradeLog.respText}</p>
              <p>Status Code: {gradeLog.statusCode}</p>
              <p>Info: {gradeLog.info}</p>
            </div>
          </div>
        </div>
      ) : (
        <div
          onClick={handleOpenState}
          className="gradeLog-closed"
          style={{
            cursor: 'pointer',
            border: '1px solid darkblue',
            marginTop: '.1em',
            padding: '4px',
            borderRadius: '4px',
          }}
        >
          {`${gradeLog.user.email} | ${gradeLog.course.coursenum} | ${
            gradeLog.activity.title
          } | ${gradeLog.submission.points || 0}/${
            gradeLog.activity.points
          } | ${gradeLog.createDate}`}
        </div>
      )}
    </div>
  )
}
